import type { WindSpeed } from "../types";

export const WIND_STRENGTH: Record<WindSpeed, number> = {
  none: 0,
  normal: 1,
  moderate: 1.8,
  high: 2.8,
};

export function windStrength(speed?: WindSpeed): number {
  return WIND_STRENGTH[speed ?? "normal"];
}
